import { z } from 'zod';
export const textOptionsSchema = z.object({});
export const textCellSchema = z.string();
//# sourceMappingURL=text.js.map